import { makeEndpointFns } from '../fns';
import { SessionActiveDevice } from '@whiz-cart/node-shared/models/session/activeDevice';

const { GET } = makeEndpointFns('storeManager');

export const session = {
    activeDevices: GET('api/v1/session/{storeGuid}/activeDevices/', SessionActiveDevice.array()),
};
